import ActionCard from './ActionCard.vue';
import Button from './Button.vue';
import Card from './Card.vue';
import CheckBox from './CheckBox.vue';
import Column from './Column.vue';
import ComboBox from './ComboBox.vue';
import Confirm from './Confirm.vue';
import Dashboard from './Dashboard.vue';
import Datepicker from './Datepicker.vue';
import Drawer from './Drawer.vue';
import Dropdown from './Dropdown.vue';
import DropdownItem from './DropdownItem.vue';
import ExpandTab from './ExpandTab.vue';
import Field from './Field.vue';
import Frame from './Frame.vue';
import Grid from './Grid.vue';
import GridColumn from './GridColumn.vue';
import GridSelector from './GridSelector.vue';
import HelpButton from './HelpButton.vue';
import Input from './Input.vue';
import Layout from './Layout.vue';
import Loading from './Loading.vue';
import Modal from './Modal.vue';
import MultiSelect from './MultiSelect.vue';
import Navbar from './Navbar.vue';
import Notification from './Notification.vue';
import NotificationPanel from './NotificationPanel.vue';
import Notifications from './Notifications.vue';
import NotificationsList from './NotificationsList.vue';
import Pagination from './Pagination.vue';
import RadioButtons from './RadioButtons.vue';
import SearchBar from './SearchBar.vue';
import Sidebar from './Sidebar.vue';
import SidebarMenu from './SidebarMenu.vue';
import SidebarMenuItem from './SidebarMenuItem.vue';
import TabStrip from './TabStrip.vue';
import TabStripItem from './TabStripItem.vue';
import TextOverflow from './TextOverflow.vue';
import Title from './Title.vue';
import Upload from './Upload.vue';
import UserInformation from './UserInformation.vue';
import InputNumeric from './InputNumeric.vue';
import TextArea from './TextArea.vue';
// import OdataGrid from './odataGrid/OdataGrid.vue'
import Tip from './Tip.vue';
import InfoCard from './InfoCard.vue';
import BlobImage from './BlobImage.vue';

export default [
  ActionCard,
  Button,
  Card,
  CheckBox,
  Column,
  ComboBox,
  Confirm,
  Dashboard,
  Datepicker,
  Drawer,
  Dropdown,
  DropdownItem,
  ExpandTab,
  Field,
  Frame,
  Grid,
  GridColumn,
  GridSelector,
  HelpButton,
  Input,
  Layout,
  Loading,
  Modal,
  MultiSelect,
  Navbar,
  Notification,
  NotificationPanel,
  Notifications,
  NotificationsList,
  Pagination,
  RadioButtons,
  SearchBar,
  Sidebar,
  SidebarMenu,
  SidebarMenuItem,
  TabStrip,
  TabStripItem,
  TextOverflow,
  Title,
  Upload,
  UserInformation,
  InputNumeric,
  TextArea,
  // OdataGrid,
  Tip,
  InfoCard,
  BlobImage,
];
